import { MealPreferences } from "@/clients/models/MealPreferences";
import { MealTime } from "@/clients/models/MealTime";
import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateMealPreferences = (mealTime: MealTime) => {
  const { mutate, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.MEAL_PREFERENCES, mealTime],
    mutationFn: async (mealPreferences: MealPreferences) => {
      const user = guardGetUserFromLocalStorage();
      if (!user) {
        throw new Error("User not found");
      }
      const { data } =
        await MealPreferencesService.updateMealPreferencesApiV1MealPreferencesMealTimePut(
          mealTime,
          user.id,
          mealPreferences,
        );

      return data;
    },
  });

  return {
    updateMealPreferences: mutate,
    isUpdating: isPending,
    isError,
    error,
  };
};
